<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">{{ form.modal.title }}</h4>
        </div>
        <div class="modal-body">
          <div class="panel-body">
            <div class="row panel-heading">
              <div class="col-sm-12 text-center">
                <form
                  class="form-inline search-fields"
                  @submit.prevent="form.onSiteSearch('trapSiteId')"
                >
                  <div class="form-group">
                    <select
                      class="form-control"
                      id="searchField"
                      name="searchField"
                      v-model="form.siteSearch.field"
                    >
                      <option value="site">Site</option>
                      <option value="trapNumber">Trap #</option>
                      <option value="trapType">Trap Type</option>
                      <option value="location">Location</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <input
                      type="search"
                      placeholder="search sites"
                      class="form-control"
                      v-model="form.siteSearch.term"
                    />
                    <span
                      class="input-group-addon pointer"
                      v-on:click="form.onSiteSearch('trapSiteId')"
                      title="search"
                      ><i class="fa fa-search"></i
                    ></span>
                  </div>
                  <i
                    class="fa fa-spinner fa-spin"
                    v-if="siteSearch.loading"
                  ></i>
                  <button
                    type="button"
                    class="btn btn-default ml-20"
                    v-if="!siteSearch.loading"
                    v-on:click="newSite"
                  >
                    Create new site
                  </button>
                </form>
              </div>
            </div>
          </div>

          <form
            @submit.prevent="form.onSubmit"
            @keydown="form.errors.clear($event.target.id)"
          >
            <input type="hidden" name="id" v-model="form.data.id" />

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('trapSiteId') }"
            >
              <label class="control-label">Site</label>
              <div class="form-group">
                <select
                  class="form-control"
                  v-model="form.data.trapSiteId"
                  v-on:change="setSelected"
                >
                  <option
                    v-for="item in siteSearch.sites"
                    v-bind:value="item.id"
                    :key="item.id"
                    >{{ item.attributes.site.name }}</option
                  >
                </select>
              </div>
              <span
                class="help-block"
                v-if="form.errors.has('trapSiteId')"
                v-text="form.errors.get('trapSiteId')"
              ></span>
            </div>

            <div class="site-details">
              <div class="row">
                <div class="col-xs-12 col-sm-4 col-sm-offset-2">
                  <strong>Name:</strong> {{ siteSearch.selected.site.name }}
                </div>
                <div class="col-xs-12 col-sm-4">
                  <strong>Location:</strong>
                  {{ siteSearch.selected.site.address }},
                  {{ siteSearch.selected.site.city }},
                  {{ stateName(siteSearch.selected.site.stateId) }}
                  {{ siteSearch.selected.site.zip }}
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-4 col-sm-offset-2">
                  <strong>Trap #:</strong> {{ siteSearch.selected.trapNumber }}
                </div>
                <div class="col-xs-12 col-sm-4">
                  <strong>Trap Type:</strong>
                  {{ trapTypeName(siteSearch.selected.trapTypeId) }}
                </div>
              </div>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('dateTrapSet') }"
            >
              <label class="control-label">Date Trap Set</label>
              <date-picker v-model="form.data.dateTrapSet"></date-picker>
              <span
                class="help-block"
                v-if="form.errors.has('dateTrapSet')"
                v-text="form.errors.get('dateTrapSet')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('dateProcessed') }"
            >
              <label class="control-label">Date Processed</label>
              <date-picker v-model="form.data.dateProcessed"></date-picker>
              <span
                class="help-block"
                v-if="form.errors.has('dateProcessed')"
                v-text="form.errors.get('dateProcessed')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('idInitials') }"
            >
              <label class="control-label">Id Initials</label>
              <input
                type="text"
                class="form-control"
                id="idInitials"
                v-model="form.data.idInitials"
              />
              <span
                class="help-block"
                v-if="form.errors.has('idInitials')"
                v-text="form.errors.get('idInitials')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('rainfall') }"
            >
              <label class="control-label">Rainfall (inches)</label>
              <input
                type="text"
                class="form-control"
                id="rainfall"
                v-model="form.data.rainfall"
              />
              <span
                class="help-block"
                v-if="form.errors.has('rainfall')"
                v-text="form.errors.get('rainfall')"
              ></span>
            </div>

            <div
              class="checkbox"
              :class="{ 'has-error': form.errors.has('tested') }"
            >
              <label>
                <input type="checkbox" id="tested" v-model="form.data.tested" />
                Tested
              </label>
              <span
                class="help-block"
                v-if="form.errors.has('tested')"
                v-text="form.errors.get('tested')"
              ></span>
            </div>

            <div
              class="form-group"
              :class="{ 'has-error': form.errors.has('workStatus') }"
            >
              <label class="control-label">Work Status</label>
              <select class="form-control" v-model="form.data.workStatus">
                <option v-for="item in workStatus">{{ item }}</option>
              </select>
              <span
                class="help-block"
                v-if="form.errors.has('workStatus')"
                v-text="form.errors.get('workStatus')"
              ></span>
            </div>

            <loading-button
              :loading="form.loading"
              class="btn btn-primary"
              :disabled="form.errors.any()"
              >Save</loading-button
            >
            <button type="button" class="btn btn-default" data-dismiss="modal">
              cancel
            </button>
          </form>
        </div>
        <div class="modal-footer"></div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
import LoadingButton from '@/components/loading-button';
import DatePicker from '@/components/date-picker';

export default {
  name: 'adult-surveillance-form',

  props: ['form'],

  data() {
    return {
      siteSearch: this.$store.getters.siteSearch,
    };
  },

  components: {
    LoadingButton,
    DatePicker,
  },

  methods: {
    trapTypeName(id) {
      return this.$store.getters.trapTypeNameById(id);
    },
    stateName(id) {
      return this.$store.getters.stateNameById(id);
    },
    setSelected() {
      this.$store.dispatch('setSiteSearchSelected', this.form.data.trapSiteId);
    },
    newSite() {
      this.form.hideEdit();
      this.$router.push({ name: 'data-sites-new' });
    },
  },

  computed: {
    workStatus() {
      return this.$store.getters.workStatus;
    },
  },

  created() {
    this.$store.dispatch('setSiteSearchClear');
  },
};
</script>
